import React from "react";

const ResidentialVillas = () => {
  // Additional images for Residential Villas
//   const additionalImages = [
//     "/images/Picture31.jpg",
//     "/images/Picture5.jpg",
//     "/images/Picture6.jpg",
//   ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">Residential Villas</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Luxury Residential Projects by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            <strong>PACIFIC BUILDERS (PVT) LTD</strong> also offers customized construction services in the residential sector. Below are a few of the luxury villas we have successfully completed and handed over to our clients recently.
          </p>

          <ul className="list-disc pl-5 text-gray-700 space-y-1">
            <li>Shaheen Shahid Housing, 2 kanal villa in F-11/3, Islamabad</li>
            <li>2 kanal villa in DHA EME, 29-J, Lahore</li>
            <li>2 kanal villa in DHA Phase 6, Lahore</li>
            <li>1 kanal villa in Johar Town, Lahore</li>
            <li>1 kanal villa in PCSIR, Lahore</li>
            <li>1 kanal villa in Architects Housing Society, Lahore</li>
          </ul>

          <div className="text-lg text-gray-700">
            <p><strong>Featured Project:</strong> Luxury Villa in DHA EME, Lahore</p>
            <p><strong>Status:</strong> Complete</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture19.jpg"
            alt="Luxury Villa DHA EME"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {/* {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Residential Villa ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default ResidentialVillas;
